import { Container } from "reactstrap"
import styles from './RetailerPicks.module.scss'
import { useState } from "react"
import CurrentBoostedProducts from "./CurrentBoostedProducts/CurrentBoostedProducts"
import BoostHistory from './BoostHistory/BoostHistory'

const RetailerPicks = () => {

  const tabs = ['Current Boosted Products', 'Boost History']
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Retailer Picks</h4>

        <div className='p-2 bg-white'>

          <div className={styles['wrapper']}>
            <p>Welcome to the Retailer Pick page! Here, we highlight products that are receiving a special boost from our platform.</p>
            <ul>
              <li>This feature is designed to increase the visibility and sales potential of your products by placing them in premium spots and promoting them to a broader audience. Each boost period lasts for a limited time, ensuring maximum impact during the promotion.</li>
              <li>
                Only 8 products can be boosted at any given time, so make sure to take advantage of this opportunity!
              </li>
            </ul>
          </div>
        </div>

        <div className="d-flex my-3 gap-3">
          {tabs.map((tab, index) => (
            <div
            key={index}
              className="fw-semibold"
              style={{
                color: tab === activeTab ? "#EC7426" : 'black',
                cursor: "pointer",
                transition: "color 0.3s ease",
                fontSize: "1rem",
                padding: '.5rem 0rem'
              }}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>

        {activeTab === 'Current Boosted Products' && <CurrentBoostedProducts />}
        {activeTab === 'Boost History' && <BoostHistory />}


      </Container>
    </div>
  )
}

export default RetailerPicks  